import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const noticeStyle = css`
	margin: 0;
	padding: 0.75rem 1rem;
	border-radius: ${theme.radii.small};
	background-color: ${theme.states.warning.surface};
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.states.warning.ink};
`;

type Props = {
	readonly unpricedItemCount: number;
};

/** Items without a price are never read as free: the notice says their cost is unknown. */
const UnpricedNotice: React.FC<Props> = ({ unpricedItemCount }) => {
	return (
		<ConditionalLoader data={unpricedItemCount > 0}>
			<p css={noticeStyle}>
				{unpricedItemCount === 1
					? "dont 1 traitement sans tarif : son coût n'est pas connu, il n'est pas compté dans le total. Ce n'est pas un traitement gratuit."
					: `dont ${unpricedItemCount} traitements sans tarif : leur coût n'est pas connu, ils ne sont pas comptés dans le total. Ce n'est pas un traitement gratuit.`}
			</p>
		</ConditionalLoader>
	);
};

export default UnpricedNotice;
